import { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Popup from '../components/modal/popup/popup'
import { PopupText } from '../components/modal/popup/popup-styles'
import { ApiContext } from '../contexts/api-context'
import { ModalContext } from '../contexts/modal-context'
import { SeatBooking } from '../types/andTypes'

const useBusinessUnit = () => {
  const { userProfile, seatBookings, getBusinessUnitsBookings } = useContext(ApiContext)
  const { setModalOpen, setModalContent } = useContext(ModalContext)
  const navigate = useNavigate()

  const [selectedBUId, setSelectedBUId] = useState<string>()
  const [seatsBooked, setSeatsBooked] = useState<SeatBooking[]>([])

  const closeModal = () => {
    setModalOpen(false)
  }

  useEffect(() => {
    if (userProfile) {
      if (userProfile.businessUnit) {
        if (!selectedBUId) {
          setSelectedBUId(userProfile.businessUnit)
        }
        setModalOpen(false)
      } else {
        const buttonConfig = [
          {
            text: 'Go to my profile',
            isPrimary: true,
            onClick: () => {
              navigate('/profile')
              setModalOpen(false)
            }
          }
        ]
        setModalContent(
          <Popup
            header="Let's get you started"
            buttonConfig={buttonConfig}
            onPopupClose={closeModal}
          >
            <PopupText>Please complete your profile</PopupText>
          </Popup>
        )
        setModalOpen(true)
      }
    }
  }, [userProfile])

  useEffect(() => {
    selectedBUId && setSeatsBooked(getBusinessUnitsBookings(selectedBUId))
  }, [selectedBUId, seatBookings])

  return { selectedBUId, setSelectedBUId, seatsBooked }
}

export default useBusinessUnit
